import { createElement } from 'react'

import { Box, Icon, Table, Text, colors } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson } from '@factorialco/f0-react'

import buildUrl from 'modules/core/lib/buildUrl'

import { CustomTooltip } from 'modules/finance/components/FinancialWorkspace/components/CustomTooltip'
import {
  dashedRowProps,
  stickyColumnProps,
} from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import {
  STICKY_CELL_WIDTH,
  WEIGHT,
} from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/const'

interface Props {
  title: string
  level?: number
  grey?: boolean
  italic?: boolean
  dashed?: boolean
  tooltip?: string
  active?: boolean
  subLabel?: string
  showImage?: boolean
  imageUrl?: string | null
  children?: React.ReactNode
  hasSiblingWithChildren?: boolean
  parentHasGrandChildren?: boolean
  titleWrapper?: React.FC<{ children: React.ReactNode }>
}

const PADDING_LEFT: Record<string, number> = {
  0: 24,
  1: 44,
  2: 64,
}

export const StickyCell = ({
  grey,
  title,
  active,
  italic,
  dashed,
  tooltip,
  imageUrl,
  children,
  subLabel,
  showImage,
  level = 0,
  titleWrapper,
  hasSiblingWithChildren,
}: Props) => {
  const Title = tooltip ? (
    <Box flexDirection="row" gap="s4" alignItems="center">
      {title}
      {tooltip && (
        <CustomTooltip label={tooltip}>
          <Icon.Medium icon="info-circle-line" color={grey ? 'grey700' : 'grey1000'} />
        </CustomTooltip>
      )}
    </Box>
  ) : (
    title
  )

  return (
    <Table.Cell
      sticky={stickyColumnProps}
      rowClickable
      wide
      style={{
        width: STICKY_CELL_WIDTH,
        minWidth: STICKY_CELL_WIDTH,
        paddingLeft: PADDING_LEFT[level]
          ? `${PADDING_LEFT[level] + (hasSiblingWithChildren ? 21 : 0)}px`
          : undefined,
        ...(grey ? { backgroundColor: colors.grey100 } : {}),
        ...(dashed ? dashedRowProps : {}),
      }}
    >
      <Box flexDirection="row" gap="s8">
        {showImage && (
          <F0AvatarPerson
            size="small"
            deactivated={!active}
            src={buildUrl(imageUrl)}
            lastName={title.split(' ')[1] || ''}
            firstName={title.split(' ')[0] || ''}
          />
        )}
        <Box flexDirection="column">
          <Text.Normal
            ellipsis
            size="200"
            weight={WEIGHT[level]}
            color={grey ? 'grey800' : 'grey1000'}
            fontStyle={italic ? 'italic' : 'normal'}
          >
            {titleWrapper ? createElement(titleWrapper, undefined, Title) : Title}
          </Text.Normal>
          {subLabel ? (
            <Text.Normal
              ellipsis
              size="200"
              weight={WEIGHT[level]}
              color={grey ? 'grey800' : 'grey1000'}
              fontStyle={italic ? 'italic' : 'normal'}
            >
              {subLabel}
            </Text.Normal>
          ) : null}
          {children}
        </Box>
      </Box>
    </Table.Cell>
  )
}
